var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreOptions = function SvgMoreOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "more-options_svg__path-1",
    d: "M9.067 12c0 1.04-.827 1.867-1.867 1.867A1.855 1.855 0 0 1 5.333 12c0-1.04.827-1.867 1.867-1.867S9.067 10.96 9.067 12M12 10.133c-1.04 0-1.867.827-1.867 1.867s.827 1.867 1.867 1.867 1.867-.827 1.867-1.867-.827-1.867-1.867-1.867m4.8 0c-1.04 0-1.867.827-1.867 1.867s.827 1.867 1.867 1.867 1.867-.827 1.867-1.867-.827-1.867-1.867-1.867M24 12c0 6.613-5.387 12-12 12S0 18.613 0 12 5.387 0 12 0s12 5.387 12 12m-1.067 0c0-6.027-4.906-10.933-10.933-10.933S1.067 5.973 1.067 12 5.973 22.933 12 22.933 22.933 18.027 22.933 12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-options_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-options_svg__icons-badges-variations",
    transform: "translate(-327 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-options_svg__icons/more-options",
    transform: "translate(327 237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "more-options_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#more-options_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#more-options_svg__path-1",
    id: "more-options_svg__Shape",
    fill: "#1A1A1A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "more-options_svg__color/black-tint/0-000000",
    fill: "#000",
    fillRule: "evenodd",
    mask: "url(#more-options_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "more-options_svg__gray-70-4A4A4A",
    d: "M0 0h24v24H0z"
  })))))));
};
export default SvgMoreOptions;